import { DATE_PARAMETER_WIRE_KEY } from "./constants";
import type { DateParameter } from "~/graphql/supergraphTypes";

/** Concrete date, as ISO `yyyy-MM-dd`, chosen for each required parameter. */
export type DateParameterValues = Partial<Record<DateParameter, string | null>>;

/** The slice of `usePreviewDateParameters` the date inputs need. Passed around
 * as one value so a surface can't render the inputs while leaving the change
 * handler unwired. */
export type DateParameterFieldsState = {
  requiredParameters: readonly DateParameter[];
  values: DateParameterValues;
  setValue: (parameter: DateParameter, value: string | null) => void;
};

export const hasAllDateParameterValues = (
  required: readonly DateParameter[],
  values: DateParameterValues,
): boolean => required.every((parameter) => Boolean(values[parameter]));

/** Builds the `parameters` blob sent with the preview mutation, keyed by the
 * snake_case tokens the semantic layer resolves against. */
export const toPreviewParameters = (
  required: readonly DateParameter[],
  values: DateParameterValues,
): Record<string, string> =>
  Object.fromEntries(
    required
      .map((parameter) => [DATE_PARAMETER_WIRE_KEY[parameter], values[parameter]])
      .filter((entry): entry is [string, string] => Boolean(entry[1])),
  );
